import { defineRelease } from '../types'

const ORG_ADMINS = ['iam_org_admin', 'iam_superadmin']

export default defineRelease({
  version: '2026.10.1',
  date: '2026-10-04',
  summary: 'Directory sync schedules, AI for free trials, and trial management.',
  entries: [
    {
      id: 'ldap-sync-schedule',
      type: 'new',
      module: 'admin',
      title: 'Choose how often your directory syncs',
      body: 'Set incremental and full LDAP sync intervals, from every 5 minutes to weekly, or switch to manual only.',
      link: { to: '/admin/auth?section=ldap', label: 'Open LDAP settings' },
      roles: ORG_ADMINS,
    },
    {
      id: 'trial-ai-included',
      type: 'new',
      module: 'helpdesk',
      title: 'AI is included in your free trial',
      body: 'Summarize tickets, draft replies and classify requests without adding your own AI key. Track the trial allowance on the AI Provider page.',
      link: { to: '/admin/ai-provider', label: 'View AI usage' },
      roles: [...ORG_ADMINS, 'ticketing_admin'],
      trialOnly: true,
      service: 'ticket-mgmt',
    },
    {
      id: 'share-ai-with-trials',
      type: 'new',
      module: 'platform',
      title: 'Share your AI provider with trial organisations',
      body: 'Let trial orgs try AI features on the platform key, with a token limit per trial. Your prompts and chatbot settings stay private.',
      link: { to: '/admin/ai-provider', label: 'Open AI Provider' },
      roles: ['iam_superadmin'],
      platformOnly: true,
    },
    {
      id: 'trial-length-setting',
      type: 'new',
      module: 'platform',
      title: 'Set how long free trials last',
      body: 'Change the trial length for new organisations from the free_trial plan in Plan management.',
      link: { to: '/admin/billing', label: 'Open Plan management' },
      roles: ['iam_superadmin'],
      platformOnly: true,
    },
    {
      id: 'extend-org-trial',
      type: 'new',
      module: 'platform',
      title: 'Extend or reopen an organisation’s trial',
      body: 'Move any organisation’s trial end date from the new Free trials list. A future date reopens an expired trial.',
      link: { to: '/admin/billing', label: 'Open Free trials' },
      roles: ['iam_superadmin'],
      platformOnly: true,
    },
    {
      id: 'trial-end-date-fix',
      type: 'fixed',
      module: 'admin',
      title: 'Trial end dates now show correctly',
      body: 'Recently created organisations saw no trial end date on the Billing page. It now shows the real date.',
      link: { to: '/admin/billing', label: 'Open Billing' },
      roles: ORG_ADMINS,
      trialOnly: true,
    },
  ],
})
